export default "__VITE_ASSET__CdWHap_X__"